let paddleReadyPromise: Promise<void> | null = null

type CheckoutSettings = {
  displayMode: "overlay" | "inline"
  variant?: "one-page" | "multi-page"
  successUrl?: string
}

type PaddleInitOptions = {
  token: string
  environment: string
  eventCallback?: (data: { name: string }) => void
  checkoutSettings?: CheckoutSettings
}

function waitForPaddle(): Promise<void> {
  return new Promise((resolve) => {
    const check = (): void => {
      if (typeof (window as { Paddle?: unknown }).Paddle !== "undefined") {
        resolve()
        return
      }
      window.setTimeout(check, 50)
    }
    check()
  })
}

export function initializePaddle(options: PaddleInitOptions): Promise<void> {
  if (!paddleReadyPromise) {
    paddleReadyPromise = waitForPaddle()
      .then(() => {
        Paddle.Environment.set(options.environment)
        return Paddle.Initialize({
          token: options.token,
          ...(options.eventCallback && { eventCallback: options.eventCallback }),
          ...(options.checkoutSettings && { checkout: { settings: options.checkoutSettings } })
        })
      })
      .then(() => undefined)
    paddleReadyPromise.catch(() => {
      paddleReadyPromise = null
    })
  }
  return paddleReadyPromise
}
